/**
 * Return the browser-facing image URL for a product.
 * When the product has an `image_seo_name` (e.g.
 * 'pink-bridal-lehenga-morrisville-nc.webp'), route the request through the
 * backend so the URL contains a keyword-rich filename that helps SEO / Google
 * Image indexing. Falls back to the raw `image` string (URL or base64) when no
 * SEO name is stored yet.
 */
const API_BASE = process.env.REACT_APP_BACKEND_URL;

export function productImageUrl(product) {
  if (!product) return '';
  if (product.image_seo_name && API_BASE) {
    return `${API_BASE}/api/images/${product.image_seo_name}`;
  }
  return product.image || '';
}
